import { NavBannerProps } from '..';

export const FREE_GIFT_BANNER_CONTENT: NavBannerProps = {
  iconName: 'gift',
  text: 'FREE gift (up to $52 value!) when you subscribe today',
};
